import classNames from 'classnames';
import { theme } from '../../styles';
import './spinner.css';

export function Spinner({ color = theme.aqua, className }: { color?: string; className?: string }) {
  return (
    <svg
      role="progressbar"
      className={classNames('svg-inline--fa', 'spinner', className, 'mi-ui-spinner-wrapper')}
      viewBox="0 0 50 50"
    >
      <circle
        className="mi-ui-spinner-path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
        stroke={color ? color : undefined}
      ></circle>
    </svg>
  );
}
